import { filterFalsy, filterFalsyArray } from "./filter-falsy";

export const RxjsUtils = {
    filterFalsy,
    filterFalsyArray,
};
